<template>
  <v-container fluid class="px-0">
    <v-row>
      <v-col
        cols="12"
        sm="12"
        class="pa-sm-5 pa-md-8 pa-lg-12 d-flex justify-center align-center flex-column"
        style="min-height: 10vh"
      >
        <h4 class="text-center font-weight-regular">
          El modelo educativo de UVAL se basa en revisión de materiales
          escritos, elaboración de actividades y evaluaciones por materia, que
          te permitirán obtener las habilidades necesarias para implementarlas
          en el mundo laboral, con acceso 24/7 a la plataforma interactiva para
          que puedas cumplir con la planeación establecida en nuestro modelo
          educativo.
        </h4>
      </v-col>
    </v-row>
    <v-row style="background: linear-gradient(to right, #1b44d6, #081a81)">
      <v-col cols="12" sm="12" md="6" lg="7" class="pa-sm-5 pa-md-8 pa-lg-12">
        <v-img
          contain
          src="/maestria/laptop_1.png"
          height="60vh"
          width="100%"
        ></v-img>
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="6"
        lg="5"
        class="pa-sm-5 pa-md-8 pa-lg-12 d-flex justify-center align-center flex-column"
        style="min-height: 50vh"
      >
        <h4 class="text-justify font-weight-regular white--text">
          En la Maestría en Educación dominarás información y tomarás decisiones
          en la oferta educativa, administración, y procesos de
          enseñanza-aprendizaje de las instituciones, compartirás conocimientos
          al alumnado, empleando técnicas y métodos de enseñanza-aprendizaje,
          realizaras investigaciones para identificar fenómenos educativos que
          puedan mejorarse y atenderse, planearás la mejora y transformación de
          los procesos educativos, planearás la estructura curricular y además
          diseñaras proyectos educativos.
        </h4>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>